<template>
  <button class="CarouselArrowButton">
    <svg width="90" height="90" viewBox="-45 -45 90 90">
      <circle r="45" fill="#08192E"/>
      <polyline
        :transform="reverse ? 'scale(-1 1)' : null"
        points="-4.5,-9 4.5,0 -4.5,9"
        fill="none"
        stroke="white"
        stroke-width="3.5"
      />
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    reverse: Boolean,
  },
}
</script>

<style scoped>
.CarouselArrowButton {
  transition: opacity 0.15s;
}
.CarouselArrowButton:hover {
  opacity: 0.85;
}
</style>
